import { Component, ChangeDetectionStrategy } from '@angular/core';
import { OptionComponent } from '../abstract/option.component';
import { intersection, flatten } from 'lodash'; 
import { Option } from '../../../../../classes';

@Component({
  selector: 'option-afterschool',
  styleUrls: ['./option-afterschool.component.scss'],
  templateUrl: './option-afterschool.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OptionAfterschoolComponent extends OptionComponent {
  filterWithTags () {
		
    if (
      this.option.tags.length !== 0 
      && this.auth.tags.length !== 0 
      && intersection(this.auth.tags, this.option.tags).length === 0
    ) return false;
    else return true;
  }


  toggleCheck () {
    if (!this.reply.isChecked(this.option)) {
      if (this.option.question.canHaveQuotaOptions) {
        const checked_siblings = flatten(this.option.question.survey.getQuestions({type:'afterschool', canHaveQuotaOptions:true}).map(q=>q.options.filter(o=>this.reply.isChecked(o) && o.id !== this.option.id)));
        const overlapping_sibling = checked_siblings.find(sibling=>this.isOverlaping(this.option, sibling));
        if (overlapping_sibling) return alert('ì ì²­í ê³¼ëª©ì¤ ìê°ì´ ê²¹ì¹ë ê³¼ëª©ì´ ììµëë¤.');
      }
    }
    return super.toggleCheck();
  }


  isOverlaping (o1:Option, o2:Option):boolean {
    const overlappingHour1 = o1.hours.find(hour1=>{
      const overlappingHour2 = o2.hours.find(hour2=>{
        if (hour1.dayIndex !== hour2.dayIndex) return false;
        const start1 = Number(hour1.start.replace(/[\D]/g, ''));
        const end1 = Number(hour1.end.replace(/[\D]/g, ''));
        const start2 = Number(hour2.start.replace(/[\D]/g, ''));
        const end2 = Number(hour2.end.replace(/[\D]/g, ''));
        return (start2 <= start1 && start1 < end2) || (start2 <= end1 && end1 < end2);
      });
      return overlappingHour2 ? true : false;
    });
    return overlappingHour1 ? true : false;

  }
}
